export default __webpack_public_path__ + "static/media/Consultoria-PT.4842f739.png";